// Development API URL
const API_BASE_URL ="https://api-dev.theskillgenie.com";

export default API_BASE_URL;



